// @flow
import type { PaymentMethod } from 'api/userDashboard';
import { removeId } from 'utils/functional';
import type { Action } from '../actions/paymentMethods';

export type PaymentMethods = {
  methods?: Array<PaymentMethod>,
  isFetching: boolean
};

export type State = PaymentMethods;

export default function invites(
  state: State = { isFetching: false },
  action: Action
) {
  switch (action.type) {
    case 'FETCH_PAYMENT_METHODS_REQUEST':
      return {
        ...state,
        isFetching: true
      };
    case 'FETCH_PAYMENT_METHODS_SUCCESS':
      return {
        ...state,
        isFetching: false,
        methods: action.methods
      };
    case 'ADD_PAYMENT_METHOD': {
      const methods = state.methods || [];
      return {
        ...state,
        methods: [...methods, action.method]
      };
    }
    case 'REMOVE_PAYMENT_METHOD': {
      const methodId = action.methodId;
      const methods = state.methods;
      if (!methods) {
        return state;
      }
      return {
        ...state,
        methods: removeId(methods || [], methodId)
      };
    }
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
